<template>
  <div
    v-show="catalogLoaded"
    style="width: 100%; height: 100%;padding-top: 20px;padding-bottom: 20px;"
    ref="widget"
    class="snapsupplements-catalog"
    :data-token="token"
  >
    <iframe
      @load="loadCatalogIframe"
      frameborder="0"
      width="100%"
      class="snapsupplements-catalog__iframe"
      ref="catalogIframe"
      v-show="catalogLoaded"
      :style="`height: calc(100% - 50px)`"
      :data-token="token"
    ></iframe>
    <catalog
      :product-click="openProductDetails.bind(null)"
      :in-iframe="catalogLoaded"
      ref="cat"
      :set-height="setCatalogHeight.bind(null)"
      :catalog-iframe="this.$refs.catalogIframe"
      :token="token"
    ></catalog>

    <iframe
      @load="loadModalIframe"
      frameborder="0"
      width="100%"
      height="100%"
      class="snapsupplements-catalog__modal"
      :data-token="token"
      ref="modalIframe"
      v-show="showModal"
      :style="`display: block;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      width: 100vw;
      height: 100vh;
      max-width: 100%;
      min-width: 100%;
      min-height: 100%;
      z-index: 9999;`"
    ></iframe>
    <modal
      :is-shown="showModal"
      :on-close="closeModal"
      :before-modal-position="beforeModalPosition"
      :modal-iframe="this.$refs.modalIframe"
      ref="modal"
    >
      <div slot="body" ref="modalBody">
        <iframe
          :src="iframeSrc"
          width="100%"
          height="100%"
          frameborder="0"
          @load="modalLoaded = true"
        >
          <p>Your browser does not support iframes.</p>
        </iframe>
        <loader v-if="!modalLoaded"></loader>
      </div>
    </modal>
    <link
      href="https://fonts.googleapis.com/css?family=Barlow:400i&display=fallback"
      rel="stylesheet"
    />
    <p
      ref="widgetFooter"
      style="margin-top: 30px !important;
            line-height: 20px !important;
            font-family: Barlow !important;
            font-size: 14px !important;
            font-weight: normal !important;
            font-style: italic !important;
            font-stretch: normal !important;
            line-height: 1.43 !important;
            letter-spacing: normal !important;
            text-align: center !important;
            text-transform: none !important;"
    >
      Powered by
      <a
        href="https://snapsupplements.com"
        style="color: #00b359 !important; text-decoration: none !important;text-transform: none !important;"
        target="_blank"
      >Snap Supplements</a>
    </p>
  </div>
</template>

<script>
import Catalog from "./components/Catalog.vue";
import Modal from "./components/Modal.vue";
import Loader from "./components/Loader.vue";

export default {
  name: "app",
  props: {
    token: {
      type: String,
      required: true
    }
  },
  components: {
    Catalog,
    Modal,
    Loader
  },
  data() {
    return {
      showModal: false,
      catalogLoaded: false,
      modalLoaded: false,
      iframeSrc: "",
      beforeModalPosition: 0
    };
  },
  computed: {
    isSafari() {
      const ua = navigator.userAgent || navigator.vendor || window.opera;
      return ua.indexOf("Safari") !== -1 && ua.indexOf("Chrome") === -1;
    },
    isCriOS() {
      const ua = navigator.userAgent || navigator.vendor || window.opera;
      return ua.search("CriOS") !== -1;
    },
    isIOS() {
      const ua = navigator.userAgent || navigator.vendor || window.opera;
      const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
      const webkitUa = !!ua.match(/WebKit/i);
      return (
        typeof webkitUa !== "undefined" &&
        iOS &&
        webkitUa &&
        !ua.match(/CriOS/i)
      );
    },
    isInstagram() {
      const ua = navigator.userAgent || navigator.vendor || window.opera;
      return ua.indexOf("Instagram") > -1;
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (process.env.NODE_ENV === "development") {
        document.querySelector("html").classList.add("development");
      }
    });
  },
  methods: {
    loadModalIframe() {
      const iframe = this.$refs.modalIframe;
      iframe.contentDocument.body.prepend(this.$refs.modal.$el);

      if (process.env.NODE_ENV === "development") {
        const styles = document.querySelectorAll("style");
        styles.forEach(style => {
          const newStyle = style.cloneNode(true);
          iframe.contentDocument.head.prepend(newStyle);
        });
      }
      const event = new CustomEvent("svModalLoaded", {
        detail: {
          token: this.token
        }
      });
      document.body.dispatchEvent(event);
    },
    loadCatalogIframe() {
      const iframe = this.$refs.catalogIframe;
      iframe.contentDocument.body.prepend(this.$refs.cat.$el);

      if (process.env.NODE_ENV === "development") {
        const styles = document.querySelectorAll("style");
        styles.forEach(style => {
          const newStyle = style.cloneNode(true);
          iframe.contentDocument.head.prepend(newStyle);
        });
      }
      const event = new CustomEvent("svCatalogLoaded", {
        detail: {
          token: this.token
        }
      });
      document.body.dispatchEvent(event);

      this.$nextTick(() => {
        this.catalogLoaded = true;
      });
    },
    setCatalogHeight: function(height) {
      const widget = this.$refs.widget;
      height += 90; // footer height (50) + padding of widget (40)
      widget.style.height = height + "px";
    },
    openProductDetails: function(url) {
      const openUrl =
        process.env.NODE_ENV === "development"
          ? `http://snap.test/${url}`
          : `https://snapsupplements.com/${url}`;
      this.beforeModalPosition = window.pageYOffset;
      if ((this.isSafari || this.isIOS) && !this.isCriOS) {
        const redirectUrl = encodeURIComponent(window.location.href);
        location.href = `${openUrl}&scroll_top=${this.beforeModalPosition}&redirect_url=${redirectUrl}`; // go to site without popup iframe
      } else {
        this.modalLoaded = false;
        this.iframeSrc = openUrl;
        this.showModal = true;
      }
    },
    closeModal() {
      this.showModal = false;
      this.iframeSrc = "";
      this.modalLoaded = false;
    }
  }
};
</script>